import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';

import useModal from '~/hooks/useModal';

type Props = {
  onRefreshToken: () => void;
  disabled: boolean;
};

const RefreshApiTokenButton: React.FC<Props> = ({
  onRefreshToken,
  disabled,
}) => {
  const { t } = useTranslation(['deliveries']);
  const [isOpen, toggleModal] = useModal();

  return (
    <>
      <Button
        className="mr-2"
        color="primary"
        outline
        onClick={() => toggleModal(true)}
        disabled={disabled}
      >
        {t('settings:Api.refreshButton')}
      </Button>
      <Modal
        isOpen={isOpen}
        toggle={() => toggleModal()}
        modalTransition={{ timeout: 150 }}
      >
        <ModalHeader toggle={() => toggleModal()}>
          {t('settings:Api.RefreshModal.title')}
        </ModalHeader>

        <ModalBody className="pt-0">
          {t('settings:Api.RefreshModal.description')}
        </ModalBody>

        <ModalFooter>
          <Button
            className="mr-2"
            color="danger"
            outline
            onClick={() => {
              onRefreshToken();
              toggleModal(false);
            }}
          >
            {t('settings:Api.refreshButton')}
          </Button>
          <Button
            className="mr-2"
            color="primary"
            outline
            onClick={() => toggleModal(false)}
          >
            {t('settings:Api.RefreshModal.cancel')}
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default RefreshApiTokenButton;
